import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../api";

const BRAND = "#154E93";

/** Employee Profile tab: shows the digital New Hire Packet for this employee, or offers to start one. */
export default function NewHirePacketTab({ employeeId }) {
  const [d, setD] = useState(undefined);
  const [error, setError] = useState("");

  useEffect(() => {
    api.onboarding.hr.byEmployee(employeeId)
      .then(async ({ packet }) => setD(packet ? await api.onboarding.hr.get(packet.id) : null))
      .catch((e) => setError(e.message));
  }, [employeeId]);

  if (error) return <div className="text-red-600 text-sm">{error}</div>;
  if (d === undefined) return <div className="text-gray-500 text-sm">Loading…</div>;
  if (d === null) return (
    <div className="bg-white rounded-xl border p-6 max-w-2xl">
      <h3 className="font-semibold text-lg" style={{ color: BRAND }}>No New Hire Packet yet</h3>
      <p className="text-sm text-gray-600 mt-1">Send the 23-form DHHS-compliant onboarding packet. The employee completes it in the portal or the mobile app, initialing every point and signing every form electronically.</p>
      <Link to={`/admin/onboarding?employee=${encodeURIComponent(employeeId)}`} className="inline-block mt-4 px-4 py-2 rounded-lg text-white text-sm font-semibold" style={{ backgroundColor: BRAND }}>Start New Hire Packet</Link>
    </div>
  );

  const p = d.packet;
  const pct = Math.round((d.done / d.total) * 100);
  const label = { in_progress: "In progress", employee_complete: "Ready to certify", certified: "Certified", paper_requested: "Paper requested" }[p.status] || p.status;
  return (
    <div className="bg-white rounded-xl border p-6 max-w-2xl space-y-3">
      <div className="flex items-center justify-between gap-3">
        <h3 className="font-semibold text-lg" style={{ color: BRAND }}>New Hire Packet #{p.id}</h3>
        <span className="text-xs px-2.5 py-1 rounded-full bg-slate-100">{label}</span>
      </div>
      <div>
        <div className="flex justify-between text-sm text-gray-600 mb-1"><span>{d.done} of {d.total} employee forms</span><span>{pct}%</span></div>
        <div className="h-2 bg-gray-100 rounded-full"><div className="h-full rounded-full" style={{ width: `${pct}%`, backgroundColor: BRAND }} /></div>
      </div>
      <ul className="text-sm text-gray-700 space-y-1">
        <li>HR items outstanding: <b>{d.hr_missing_total}</b></li>
        <li>Required screening uploads: {d.hr_uploads.filter((u) => u.required).map((u) => `${u.on_file ? "✓" : "✗"} ${u.label}`).join(" · ")}</li>
        <li>Signed PDFs on file: <b>{d.documents.length}</b></li>
      </ul>
      <Link to={`/admin/onboarding/${p.id}`} className="inline-block px-4 py-2 rounded-lg text-white text-sm font-semibold" style={{ backgroundColor: BRAND }}>Open packet</Link>
    </div>
  );
}
